
import React from "react";
import styled from "styled-components";

const SelectField = styled.select`
    height: 3rem;
    width: 100%;
    min-width: 18rem;
    padding: 0 0.5rem;
    border: 1px solid #eeeeee;
    background-color: #ffffff;
    border-radius: 0.25rem;
`;

const Select = ({ onChange, value, options, placeholder }) => {
    return ( 
        <SelectField value={value} onChange={onChange}>
            <option value="">{placeholder}</option>
            {options.map((option) => <option key={option.id} value={option.id}>{option.name}</option>)}
        </SelectField>
     );
};
 
export default Select;